import { createRichTextV2Plugin } from "../../controls/rich-text-v2/plugin";
import { Link } from "../../controls/link";
import { ElementUtils } from "../utils/element";
import { isLinkElement } from "./types";
import { onChange } from "./onChange";
import { getValue } from "./getValue";
function LinkPlugin() {
  return createRichTextV2Plugin({
    control: {
      definition: Link({
        label: "On Click"
      }),
      onChange,
      getValue,
      getElementValue: (element) => {
        return ElementUtils.isInline(element) && isLinkElement(element) ? element.link : void 0;
      }
    }
  });
}
export {
  LinkPlugin
};
//# sourceMappingURL=linkPluginWithoutRenderElement.js.map